import {UPLOAD_IMGUR_FAILURE, UPLOAD_IMGUR_REQUEST, UPLOAD_IMGUR_SUCCESS} from '../../types/index';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';

const UploadImgurAction = (file) => ({

    [RSAA]: {
        endpoint: "https://file.notifun.com/api/files",
        method: 'POST',
        // Do NOT set Content-Type here so browser sets multipart/form-data with boundary automatically
        headers: (() => {
            const token_type = localStorage.getItem("token_type") ? JSON.parse(localStorage.getItem("token_type")) : null;
            const access_token = localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null;
            const auth = token_type && access_token ? `${token_type} ${access_token}` : undefined;
            return auth ? { Accept: "application/json", Authorization: auth } : { Accept: "application/json" };
        })(),
        body: file,
        types: [
            UPLOAD_IMGUR_REQUEST,
            {
                type: UPLOAD_IMGUR_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });

                        return {
                            "code": 0,
                            "type": UPLOAD_IMGUR_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: UPLOAD_IMGUR_FAILURE,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');

                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json()
                    }
                },
            },
        ]
    }
});

export {UploadImgurAction}